<template>
  <div class="search-bar">
    <label-input
      class="label-input"
      width="368px"
      label-width="94px"
      label="药品通用名"
      type="autocomplete"
      v-model="name"
      :query-search="querySearch"
      :input-attr="{ clearable: true }"
    />
    <label-input
      class="label-input"
      width="368px"
      v-model="barcode"
      label-width="94px"
      label="药品条形码"
      :input-attr="{ maxLength: 20, clearable: true }"
    />
    <el-button class="el-button--primary is-plain btn" @click="$emit('search')">查询</el-button>
  </div>
</template>

<script>
import labelInput from '@/components/global/form/labelInput';
import Fetch from '@/api';

export default {
  name: 'searchBar',
  components: {
    labelInput
  },
  props: {
    searchParams: {
      type: Object
    }
  },
  computed: {
    name: {
      get() {
        return this.searchParams.name;
      },
      set(val) {
        this.$emit('change', 'name', val);
      }
    },
    barcode: {
      get() {
        return this.searchParams.barcode;
      },
      set(val) {
        this.$emit('change', 'barcode', val);
      }
    }
  },
  methods: {
    querySearch(queryString, cb) {
      if (queryString.length > 1) {
        return Fetch.query_gnu_by_name({ name: queryString }).then(data => {
          if (data) {
            cb(data);
          } else {
            cb([]);
          }
        });
      } else {
        cb([]);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.search-bar {
  display: flex;
  margin-bottom: 24px;

  .label-input {
    margin-right: 16px;
  }

  .btn {
    width: 80px;
  }
}
</style>
